<template>
  <div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="720px" top="5vh"
      custom-class="work-assign-dialog" append-to-body :close-on-click-modal="true"
      :close-on-press-escape="!pickVisible" @closed="onClosed">
      <div v-loading="loading">
        <div class="assign-topic">
          <div class="assign-topic-label">当前作业主题</div>
          <div class="assign-topic-name">{{ topicName || '—' }}</div>
          <div class="assign-topic-meta">
            应提交人数：<strong>{{ total }}</strong> 人
            · 已选作业：<strong>{{ selectedSubCount }}</strong> 个
            · {{ pickMetaLabel }}：<strong>{{ pickMetaCount }}</strong>{{ pickMetaUnit }}
          </div>
          <p class="assign-basis-tip">以下分配方式均基于应提交人名单进行批改分配</p>
        </div>

        <div class="form-block">
          <div class="form-label">选择作业<span class="req">*</span></div>
          <div class="expert-toolbar" v-if="!isView">
            <el-button type="text" size="small" @click="selectAllSubs(true)">全选</el-button>
            <el-button type="text" size="small" @click="selectAllSubs(false)">清空</el-button>
            <span class="toolbar-hint">{{ subHint }}</span>
          </div>
          <div class="chip-list" v-if="subHomeworks.length">
            <div class="chip-item" v-for="item in subHomeworks" :key="item.id"
              :class="{ 'is-checked': selectedSubs[item.id], 'is-disabled': isView }">
              <el-checkbox :value="!!selectedSubs[item.id]" :disabled="isView"
                @input="toggleSub(item.id, $event)"></el-checkbox>
              <span class="chip-name">{{ item.name }}</span>
            </div>
          </div>
          <div class="empty-text" v-else>暂无作业</div>
        </div>

        <div class="form-block">
          <div class="form-label">分配方式<span class="req">*</span></div>
          <el-radio-group v-model="mode" size="small" :disabled="isView" @change="onModeChange">
            <el-radio-button label="group">按用户组分配</el-radio-button>
            <el-radio-button label="quantity">按数量分配</el-radio-button>
            <el-radio-button label="random">随机分配</el-radio-button>
          </el-radio-group>
          <p class="mode-desc">{{ modeDesc }}</p>
        </div>

        <div class="form-block">
          <div class="form-label">{{ pickLabel }}<span class="req">*</span></div>
          <div class="expert-toolbar">
            <div class="expert-toolbar-left">
              <el-button type="text" size="small" :disabled="isView" @click="selectAllPicks(true)">全选</el-button>
              <el-button type="text" size="small" :disabled="isView" @click="selectAllPicks(false)">清空</el-button>
              <span class="toolbar-hint">{{ avgHint }}</span>
            </div>
            <el-button v-show="mode === 'quantity'" type="text" size="small" :disabled="isView"
              @click="avgFill">一键均分应提交人</el-button>
          </div>

          <div v-if="mode === 'group'" class="chip-list" :class="{ 'is-disabled': isView }">
            <div class="chip-item" v-for="g in userGroups" :key="g.id"
              :class="{ 'is-checked': !isGroupAllocated(g.id) && checkedGroups[g.id], 'is-allocated': isGroupAllocated(g.id), 'is-disabled': isView || isGroupAllocated(g.id) }">
              <el-checkbox :value="isGroupAllocated(g.id) || !!checkedGroups[g.id]"
                :disabled="isView || isGroupAllocated(g.id)" @input="toggleGroup(g.id, $event)"></el-checkbox>
              <span class="chip-name">{{ g.name }}</span>
              <span class="chip-meta">{{ groupMeta(g) }}</span>
            </div>
            <div class="empty-text" v-if="!userGroups.length">暂无用户组</div>
          </div>

          <div v-else class="expert-list">
            <div class="expert-row" v-for="e in experts" :key="e.id"
              :class="{ 'is-disabled': !selected[e.id], 'is-random': mode === 'random' }">
              <el-checkbox :value="!!selected[e.id]" :disabled="isView" @input="toggleExpert(e.id, $event)"></el-checkbox>
              <span class="expert-name">{{ e.name }}</span>
              <span class="expert-meta">{{ e.groupName || e.org }}</span>
              <el-input v-if="mode === 'quantity'" class="expert-count-input" size="mini" type="number"
                :value="counts[e.id]" :disabled="isView || !selected[e.id]" placeholder="人数"
                @input="onCountInput(e.id, $event)"></el-input>
            </div>
            <div class="empty-text" v-if="!experts.length">暂无批改专家</div>
          </div>

          <div class="group-pick-bar" v-if="mode === 'group' && !isView">
            <el-button type="primary" size="small" :disabled="checkedGroupCount === 0"
              @click="openExpertPick">选择专家</el-button>
          </div>
        </div>

        <div class="form-block" v-if="mode === 'group'">
          <div class="form-label">分配记录</div>
          <div class="record-list">
            <div class="record-item is-sub" v-if="records.length">
              <div class="record-desc">本次批改作业：<strong>{{ selectedSubText }}</strong></div>
            </div>
            <div class="record-item" v-for="r in records" :key="r.id">
              <div>
                <div class="record-title">{{ r.groupNames.join('、') }}</div>
                <div class="record-desc">批改专家：{{ r.expertNames.join('、') }}<br>应提交人数：<strong>{{ r.count }}</strong> 人
                </div>
              </div>
              <el-button v-if="!isView" type="text" class="record-delete" @click="deleteRecord(r.id)">删除</el-button>
            </div>
            <div class="empty-text" v-if="!records.length">暂无分配记录，请勾选用户组并选择专家</div>
          </div>
        </div>

        <div class="form-block" v-else>
          <div class="form-label">应提交人分配预览</div>
          <div class="preview-box" v-html="previewHtml"></div>
        </div>
      </div>

      <div slot="footer">
        <el-button @click="onCancel">{{ isView ? '关闭' : '取消' }}</el-button>
        <el-button v-if="isView" @click="enterEdit">修改分配</el-button>
        <el-button v-if="!isView" type="primary" :loading="saving" @click="confirmAssign">
          {{ uiMode === 'edit' ? '保存修改' :'确认分配' }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择专家" :visible.sync="pickVisible" width="480px" append-to-body custom-class="work-assign-pick">
      <p class="nested-tip">{{ pickTip }}</p>
      <div class="nested-expert-list" v-loading="pickLoading">
        <div class="nested-expert-row" v-for="e in pickAvailable" :key="'a-' + e.id"
          :class="{ 'is-checked': String(pickDraft) === String(e.id) }">
          <el-radio v-model="pickDraft" :label="e.id">{{ e.name }}</el-radio>
          <span class="nested-expert-org">{{ expertOrgText(e) }}</span>
        </div>
        <div class="nested-expert-row is-used" v-for="e in pickUsed" :key="'u-' + e.id">
          <el-radio v-model="pickDraft" :label="e.id" disabled>{{ e.name }}</el-radio>
          <span class="used-tag">已分配{{ e.groupName ? ' · ' + e.groupName : '' }}</span>
        </div>
        <div class="empty-text" v-if="!pickAvailable.length && !pickUsed.length">暂无可选专家</div>
      </div>
      <div slot="footer">
        <el-button @click="pickVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmExpertPick">确认选择</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  const MODE_DESC = {
    group: '可多选用户组后点击「选择专家」，每位专家单选确认后生成分配记录；删除记录即取消该分配。',
    quantity: '按应提交人人数分配：为每位已选专家指定负责人数，合计不宜超过应提交人数。',
    random: '按应提交人随机分配：将全部应提交人随机均分给已选专家，余数随机补给部分专家。'
  }

  const cloneData = (obj) => JSON.parse(JSON.stringify(obj || {}))

  const isBizOk = (res) => !!(res && res.code == 200)

  const bizMsg = (res, fallback) => (res && res.msg) || fallback

  export default {
    name: 'WorkAssignDialog',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      theme: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        loading: false,
        saving: false,
        hasAssign: false,
        pickLoading: false,
        pickVisible: false,
        uiMode: 'create',
        mode: 'group',
        topicName: '',
        total: 0,
        subHomeworks: [],
        selectedSubs: {},
        userGroups: [],
        experts: [],
        selected: {},
        checkedGroups: {},
        counts: {},
        groupCounts: {},
        records: [],
        recordSeq: 1,
        pickGroupIds: [],
        pickDraft: '',
        pickAvailable: [],
        pickUsed: [],
        pickTip: '请选择一位批改专家',
        randomParts: [],
        savedSnap: null
      }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.visible
        },
        set(val) {
          this.$emit('update:visible', val)
        }
      },
      isView() {
        return this.uiMode === 'view'
      },
      dialogTitle() {
        if (this.uiMode === 'view') return '查看批改分配'
        if (this.uiMode === 'edit') return '修改作业批改分配'
        return '作业批改分配'
      },
      selectedSubList() {
        return this.subHomeworks.filter(item => this.selectedSubs[item.id])
      },
      selectedSubCount() {
        return this.selectedSubList.length
      },
      selectedSubText() {
        return this.selectedSubList.map(item => item.name).join('、') || '未选择'
      },
      subHint() {
        if (!this.subHomeworks.length) return ''
        return this.selectedSubCount
          ? `已选 ${this.selectedSubCount} / ${this.subHomeworks.length} 个作业`
          : `共 ${this.subHomeworks.length} 个作业，请至少选择 1 个`
      },
      pickLabel() {
        return this.mode === 'group' ? '选择用户组' : '选择批改专家'
      },
      pickMetaLabel() {
        if (this.mode === 'group') return '分配记录'
        return '已选专家'
      },
      pickMetaUnit() {
        return this.mode === 'group' ? ' 条' : ' 人'
      },
      pickMetaCount() {
        if (this.mode === 'group') return this.records.length
        return this.selectedExperts.length
      },
      modeDesc() {
        if (this.isView) return '当前为查看模式，点击「修改分配」可调整已有分配信息。'
        return MODE_DESC[this.mode]
      },
      allocatedGroupMap() {
        const map = {}
        this.records.forEach(r => {
          (r.groupIds || []).forEach(id => {
            map[String(id)] = true
          })
        })
        return map
      },
      allocatedExpertMap() {
        const map = {}
        this.records.forEach(r => {
          (r.expertIds || []).forEach(id => {
            map[String(id)] = true
          })
        })
        return map
      },
      checkedGroupList() {
        return this.userGroups.filter(g => this.checkedGroups[g.id] && !this.allocatedGroupMap[String(g.id)])
      },
      checkedGroupCount() {
        return this.checkedGroupList.length
      },
      selectedExperts() {
        return this.experts.filter(e => this.selected[e.id])
      },
      avgHint() {
        if (this.mode === 'group') {
          if (this.isView) return this.records.length ? `共 ${this.records.length} 条分配记录` : '暂无分配记录'
          if (this.checkedGroupCount) return `已勾选 ${this.checkedGroupCount} 个用户组，可点击选择专家`
          return this.records.length ? `已生成 ${this.records.length} 条分配记录` : ''
        }
        if (!this.selectedExperts.length) return ''
        if (this.mode === 'quantity') {
          return `人均约 ${Math.floor(this.total / this.selectedExperts.length)} 名应提交人`
        }
        return `将随机均分 ${this.total} 名应提交人`
      },
      previewHtml() {
        const picked = this.selectedExperts
        if (!picked.length) return '请先选择至少一位专家。'
        if (this.mode === 'quantity') {
          const sum = picked.reduce((s, e) => s + (Number(this.counts[e.id]) || 0), 0)
          const lines = picked.map(e => `${e.name}：负责 <strong>${Number(this.counts[e.id]) || 0}</strong> 名应提交人`)
          let status = ''
          if (sum === 0) status = '<span class="err">尚未填写应提交人分配数量</span>'
          else if (sum > this.total) status = `<span class="err">合计 ${sum} 人，超出应提交人数 ${this.total} 人</span>`
          else if (sum < this.total) status = `<span class="warn">合计 ${sum} 人，剩余 ${this.total - sum} 名应提交人暂不分配</span>`
          else status = `<span class="ok">合计 ${sum} 人，应提交人已全部分配</span>`
          return lines.join('；') + '<br>' + status
        }
        const parts = this.randomParts.length === picked.length
          ? this.randomParts
          : this.randomDistribute(this.total, picked.length)
        const lines = picked.map((e, i) => `${e.name}：约负责 <strong>${parts[i] || 0}</strong> 名应提交人`)
        return lines.join('；') + `<br><span class="ok">确认后将随机分配全部 ${this.total} 名应提交人</span>`
      }
    },
    watch: {
      visible(val) {
        if (val) this.init()
      }
    },
    methods: {
      isGroupAllocated(id) {
        return !!this.allocatedGroupMap[String(id)]
      },
      groupMeta(g) {
        const count = this.groupCounts[g.id] || 0
        return this.isGroupAllocated(g.id) ? `已分配 · ${count} 人` : `${count} 人`
      },
      expertOrgText(e) {
        return [e.groupName, e.org].filter(Boolean).join(' · ')
      },
      normalizeExpert(item) {
        return {
          id: item.id || item.userId,
          name: item.name || item.userName || item.realName || String(item.id),
          org: item.org || item.orgName || item.schoolName || item.job || item.title || '',
          groupId: item.groupId || '',
          groupName: item.groupName || item.group || ''
        }
      },
      buildGroupCounts(groups, total) {
        const result = {}
        if (!groups.length) return result
        const hasReal = groups.some(g => g.count > 0)
        if (hasReal) {
          groups.forEach(g => {
            result[g.id] = g.count
          })
          return result
        }
        const base = Math.floor(total / groups.length)
        const rem = total % groups.length
        groups.forEach((g, i) => {
          result[g.id] = base + (i < rem ? 1 : 0)
        })
        return result
      },
      randomDistribute(total, n) {
        if (n <= 0) return []
        const base = Math.floor(total / n)
        const rem = total % n
        const arr = []
        for (let i = 0; i < n; i++) arr.push(base)
        const idxs = arr.map((_, i) => i)
        for (let k = idxs.length - 1; k > 0; k--) {
          const r = Math.floor(Math.random() * (k + 1))
          const tmp = idxs[k]
          idxs[k] = idxs[r]
          idxs[r] = tmp
        }
        for (let m = 0; m < rem; m++) arr[idxs[m]] += 1
        return arr
      },
      snapshot() {
        return {
          mode: this.mode,
          selected: cloneData(this.selected),
          checkedGroups: cloneData(this.checkedGroups),
          counts: cloneData(this.counts),
          groupCounts: cloneData(this.groupCounts),
          records: cloneData(this.records),
          recordSeq: this.recordSeq,
          total: this.total,
          subHomeworks: cloneData(this.subHomeworks),
          selectedSubs: cloneData(this.selectedSubs),
          selectedExpertIds: this.selectedExperts.map(e => e.id),
          questIds: this.selectedSubList.map(item => item.id),
          questNames: this.selectedSubList.map(item => item.name)
        }
      },
      applySnapshot(data) {
        this.mode = data.mode || 'group'
        this.selected = cloneData(data.selected || {})
        this.checkedGroups = cloneData(data.checkedGroups || {})
        this.counts = cloneData(data.counts || {})
        this.groupCounts = Object.assign(this.buildGroupCounts(this.userGroups, this.total), cloneData(data.groupCounts || {}))
        this.records = cloneData(data.records || [])
        this.recordSeq = data.recordSeq || (this.records.length + 1)
        if (data.total != null) this.total = data.total
        if (!this.subHomeworks.length && data.subHomeworks && data.subHomeworks.length) {
          this.subHomeworks = cloneData(data.subHomeworks)
        }
        const savedSubs = data.selectedSubs || {}
        const questSet = {}
        ;(data.questIds || []).forEach(id => { questSet[String(id)] = true })
        const nextSubs = {}
        this.subHomeworks.forEach(item => {
          const key = item.id
          if (Object.prototype.hasOwnProperty.call(savedSubs, key) || Object.prototype.hasOwnProperty.call(savedSubs, String(key))) {
            nextSubs[key] = !!(savedSubs[key] || savedSubs[String(key)])
          } else if (data.questIds && data.questIds.length) {
            nextSubs[key] = !!questSet[String(key)]
          } else {
            nextSubs[key] = false
          }
        })
        this.selectedSubs = nextSubs
        this.rebuildRandomParts()
      },
      resetPickState() {
        this.selected = {}
        this.checkedGroups = {}
        this.counts = {}
        this.records = []
        this.recordSeq = 1
        this.selectedSubs = {}
        this.experts.forEach(e => {
          this.$set(this.selected, e.id, false)
          this.$set(this.counts, e.id, '')
        })
        this.userGroups.forEach(g => {
          this.$set(this.checkedGroups, g.id, false)
        })
      },
      applyAssignData(data) {
        if (!data) return
        this.mode = data.mode || 'group'
        if (data.submitTotal != null) this.total = Number(data.submitTotal) || 0
        if (data.themeName) this.topicName = data.themeName
        const questSet = {}
        ;(data.questionnaireIds || []).forEach(id => {
          questSet[String(id)] = true
        })
        const nextSubs = {}
        this.subHomeworks.forEach(item => {
          nextSubs[item.id] = data.questionnaireIds && data.questionnaireIds.length
            ? !!questSet[String(item.id)]
            : true
        })
        this.selectedSubs = nextSubs
        const items = data.items || []
        if (this.mode === 'group') {
          this.records = items.map((item, i) => ({
            id: item.id || ('rec-' + (i + 1)),
            groupIds: item.userGroupIds || [],
            groupNames: item.userGroupNames || [],
            expertIds: item.expertId != null ? [item.expertId] : [],
            expertNames: item.expertName ? [item.expertName] : [],
            count: Number(item.count) || 0
          }))
          this.recordSeq = this.records.length + 1
        } else {
          items.forEach(item => {
            if (item.expertId == null) return
            this.$set(this.selected, item.expertId, true)
            if (item.count != null) this.$set(this.counts, item.expertId, Number(item.count) || 0)
          })
          this.rebuildRandomParts()
        }
      },
      async init() {
        const theme = this.theme || {}
        this.topicName = theme.themeName || ''
        this.total = Number(theme.userCount || 0)
        this.uiMode = 'create'
        this.mode = 'group'
        this.hasAssign = false
        this.savedSnap = null
        this.pickVisible = false
        this.saving = false
        this.loading = true
        try {
          await this.loadBaseData()
          this.resetPickState()
          this.groupCounts = this.buildGroupCounts(this.userGroups, this.total)
          const saved = await this.loadSavedAssign(theme.id)
          if (saved) {
            this.applyAssignData(saved)
            this.savedSnap = this.snapshot()
            this.hasAssign = true
            this.uiMode = 'view'
          } else {
            this.subHomeworks.forEach(item => {
              this.$set(this.selectedSubs, item.id, true)
            })
          }
        } catch (e) {
          console.log(e)
          this.$message.error((e && e.message) || '加载批改分配数据失败')
        } finally {
          this.loading = false
        }
      },
      async loadBaseData() {
        const themeId = this.theme && this.theme.id
        if (!themeId) return
        const res = await this.$Api.Form.getCorrectAssignMeta(themeId)
        if (!isBizOk(res)) {
          throw new Error(bizMsg(res, '加载批改分配数据失败'))
        }
        const data = res.data || {}
        this.topicName = data.themeName || this.topicName
        if (data.submitTotal != null) this.total = Number(data.submitTotal) || 0
        this.subHomeworks = (data.questionnaires || []).map(item => ({
          id: item.id,
          name: item.name
        }))
        this.userGroups = (data.userGroups || []).map(g => ({
          id: g.id,
          name: g.name,
          count: Number(g.submitCount || 0)
        }))
        this.experts = (data.experts || []).map(item => this.normalizeExpert(item))
      },
      async loadSavedAssign(themeId) {
        if (!themeId) return null
        const res = await this.$Api.Form.getCorrectAssign(themeId)
        if (!isBizOk(res)) {
          if (res && res.msg && String(res.msg).indexOf('尚未分配') > -1) return null
          this.$message.error(bizMsg(res, '获取分配信息失败'))
          return null
        }
        const data = res.data
        if (!data || (!data.id && !data.mode && !(data.items && data.items.length))) return null
        return data
      },
      buildPayload() {
        const items = []
        if (this.mode === 'group') {
          this.records.forEach(r => {
            if (r.expertIds && r.expertIds[0] != null) {
              items.push({
                expertId: r.expertIds[0],
                count: Number(r.count) || 0,
                userGroupIds: r.groupIds || []
              })
            }
          })
        } else if (this.mode === 'quantity') {
          this.selectedExperts.forEach(e => {
            items.push({
              expertId: e.id,
              count: Number(this.counts[e.id]) || 0
            })
          })
        } else {
          this.selectedExperts.forEach(e => {
            items.push({ expertId: e.id })
          })
        }
        return {
          themeId: this.theme && this.theme.id,
          mode: this.mode,
          questionnaireIds: this.selectedSubList.map(item => item.id),
          items
        }
      },
      toggleSub(id, val) {
        this.$set(this.selectedSubs, id, !!val)
      },
      selectAllSubs(checked) {
        this.subHomeworks.forEach(item => {
          this.$set(this.selectedSubs, item.id, checked)
        })
      },
      toggleGroup(id, val) {
        this.$set(this.checkedGroups, id, !!val)
      },
      toggleExpert(id, val) {
        this.$set(this.selected, id, !!val)
        if (!val) this.$set(this.counts, id, '')
        this.rebuildRandomParts()
      },
      onCountInput(id, val) {
        const n = val === '' ? '' : Math.max(0, parseInt(val, 10) || 0)
        this.$set(this.counts, id, n)
      },
      selectAllPicks(checked) {
        if (this.mode === 'group') {
          this.userGroups.forEach(g => {
            if (!this.isGroupAllocated(g.id)) this.$set(this.checkedGroups, g.id, checked)
          })
        } else {
          this.experts.forEach(e => {
            this.$set(this.selected, e.id, checked)
            if (!checked) this.$set(this.counts, e.id, '')
          })
          this.rebuildRandomParts()
        }
      },
      onModeChange() {
        this.rebuildRandomParts()
      },
      rebuildRandomParts() {
        if (this.mode !== 'random') {
          this.randomParts = []
          return
        }
        this.randomParts = this.randomDistribute(this.total, this.selectedExperts.length)
      },
      avgFill() {
        const picked = this.selectedExperts
        if (!picked.length) {
          this.$message.warning('请先选择专家')
          return
        }
        const base = Math.floor(this.total / picked.length)
        const rem = this.total % picked.length
        picked.forEach((e, i) => {
          this.$set(this.counts, e.id, base + (i < rem ? 1 : 0))
        })
        this.$message.success('已按应提交人均分')
      },
      openExpertPick() {
        const groups = this.checkedGroupList
        if (!groups.length) {
          this.$message.warning('请先勾选用户组')
          return
        }
        this.pickGroupIds = groups.map(g => g.id)
        this.pickDraft = ''
        this.pickVisible = true
        const count = groups.reduce((s, g) => s + (Number(this.groupCounts[g.id]) || 0), 0)
        const usedMap = this.allocatedExpertMap
        const available = []
        const used = []
        this.experts.forEach(e => {
          if (e.id == null) return
          if (usedMap[String(e.id)]) used.push(e)
          else available.push(e)
        })
        this.pickAvailable = available
        this.pickUsed = used
        this.pickTip = `已选用户组：${groups.map(g => g.name).join('、')}（应提交 ${count} 人），请选择一位批改专家` +
          (used.length ? '；已分配专家置灰显示在下方' : '')
      },
      confirmExpertPick() {
        if (!this.pickDraft) {
          this.$message.warning('请选择一位专家')
          return
        }
        const expert = this.pickAvailable.concat(this.experts).filter(e => String(e.id) === String(this.pickDraft))[0]
        if (!expert) {
          this.$message.warning('请选择一位专家')
          return
        }
        const groups = this.userGroups.filter(g => this.pickGroupIds.indexOf(g.id) > -1)
        const count = groups.reduce((s, g) => s + (Number(this.groupCounts[g.id]) || 0), 0)
        this.records.push({
          id: 'rec-' + this.recordSeq++,
          groupIds: groups.map(g => g.id),
          groupNames: groups.map(g => g.name),
          expertIds: [expert.id],
          expertNames: [expert.name],
          count
        })
        groups.forEach(g => {
          this.$set(this.checkedGroups, g.id, false)
        })
        this.pickVisible = false
        this.$message.success('已生成分配记录')
      },
      deleteRecord(id) {
        const record = this.records.filter(r => r.id === id)[0]
        this.records = this.records.filter(r => r.id !== id)
        if (record) {
          (record.groupIds || []).forEach(gid => {
            this.$set(this.checkedGroups, gid, false)
          })
          this.$message.success(`已删除分配记录，已取消「${(record.groupNames || []).join('、')}」的分配`)
        }
      },
      enterEdit() {
        this.uiMode = 'edit'
        this.$message.success('已进入修改模式，可调整分配信息')
      },
      onCancel() {
        if (this.uiMode === 'edit' && this.savedSnap) {
          this.applySnapshot(this.savedSnap)
          this.uiMode = 'view'
          this.$message.info('已取消修改')
          return
        }
        this.dialogVisible = false
      },
      onClosed() {
        this.pickVisible = false
        this.uiMode = 'create'
      },
      async confirmAssign() {
        if (!this.selectedSubList.length) {
          this.$message.warning('请至少选择一个作业')
          return
        }
        if (this.mode === 'group') {
          if (!this.records.length) {
            this.$message.warning('请先生成至少一条分配记录')
            return
          }
          const missingGroup = this.records.some(r => !(r.groupIds && r.groupIds.length))
          if (missingGroup) {
            this.$message.warning('请先生成至少一条分配记录')
            return
          }
        } else {
          const picked = this.selectedExperts
          if (!picked.length) {
            this.$message.warning('请至少选择一位专家')
            return
          }
          if (this.mode === 'quantity') {
            const invalid = picked.some(e => Number(this.counts[e.id]) < 0)
            if (invalid) {
              this.$message.warning('请填写应提交人分配数量')
              return
            }
            const sum = picked.reduce((s, e) => s + (Number(this.counts[e.id]) || 0), 0)
            if (sum <= 0) {
              this.$message.warning('请填写应提交人分配数量')
              return
            }
            if (sum > this.total) {
              this.$message.warning('分配合计不能超过应提交人数')
              return
            }
          }
        }

        const payload = this.buildPayload()
        this.saving = true
        try {
          const res = this.hasAssign
            ? await this.$Api.Form.updateCorrectAssign(payload)
            : await this.$Api.Form.createCorrectAssign(payload)
          if (!isBizOk(res)) {
            this.$message.error(bizMsg(res, '分配失败'))
            return
          }
          this.hasAssign = true
          this.$emit('saved', {
            themeId: payload.themeId,
            assigned: true
          })
          this.dialogVisible = false
          this.$message.success(this.uiMode === 'edit' ? '修改已保存' : '分配成功')
        } catch (e) {
          this.$message.error((e && e.message) || '分配失败')
        } finally {
          this.saving = false
        }
      }
    }
  }
</script>

<style lang="less">
  .work-assign-dialog {
    border-radius: 10px;
    margin-bottom: 0;
    max-height: 90vh;
    display: flex;
    flex-direction: column;

    .el-dialog__header {
      flex-shrink: 0;
      padding: 16px 20px;
      border-bottom: 1px solid #EBEEF5;
    }

    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
    }

    .el-dialog__body {
      flex: 1;
      min-height: 0;
      padding: 20px;
      overflow-y: auto;
    }

    .el-dialog__footer {
      flex-shrink: 0;
      padding: 14px 20px;
      border-top: 1px solid #EBEEF5;
    }
  }

  .work-assign-pick {
    .el-dialog__body {
      padding: 16px 20px 8px;
    }
  }
</style>

<style lang="less" scoped>
  .assign-topic {
    padding: 12px 14px;
    background: #F5F9FF;
    border: 1px solid #D6E8FF;
    border-radius: 6px;
    margin-bottom: 18px;
  }

  .assign-topic-label {
    font-size: 12px;
    color: #909399;
    margin-bottom: 4px;
  }

  .assign-topic-name {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 6px;
  }

  .assign-topic-meta {
    font-size: 13px;
    color: #606266;

    strong {
      color: #409EFF;
      font-weight: 600;
    }
  }

  .assign-basis-tip {
    margin-top: 8px;
    font-size: 12px;
    color: #409EFF;
    line-height: 1.5;
  }

  .form-block {
    margin-bottom: 18px;
  }

  .form-label {
    font-size: 13px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 10px;
  }

  .req {
    color: #F56C6C;
    margin-left: 2px;
  }

  .mode-desc {
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
    line-height: 1.6;
  }

  .expert-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    gap: 10px;
  }

  .expert-toolbar-left {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .toolbar-hint {
    margin-left: 8px;
    font-size: 13px;
    color: #909399;
  }

  .chip-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 12px;
    border: 1px solid #EBEEF5;
    border-radius: 6px;
    background: #FAFBFC;
  }

  .chip-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    padding: 8px 12px;
    border: 1px solid #DCDFE6;
    border-radius: 6px;
    background: #fff;
    font-size: 13px;
    cursor: pointer;
    user-select: none;
    color: #606266;

    &:hover:not(.is-disabled):not(.is-allocated) {
      border-color: #409EFF;
      color: #409EFF;
    }

    &.is-checked {
      border-color: #409EFF;
      background: #ECF5FF;
      color: #409EFF;
    }

    &.is-allocated {
      border-color: #E1F3D8;
      background: #F0F9EB;
      color: #67C23A;
      cursor: default;
    }

    &.is-disabled {
      cursor: default;
    }
  }

  .chip-name {
    font-weight: 500;
    white-space: nowrap;
  }

  .chip-meta {
    font-size: 12px;
    color: #909399;
    white-space: nowrap;
  }

  .chip-item.is-checked .chip-meta,
  .chip-item.is-allocated .chip-meta {
    color: inherit;
    opacity: 0.8;
  }

  .expert-list {
    border: 1px solid #EBEEF5;
    border-radius: 6px;
    max-height: 240px;
    overflow-y: auto;
  }

  .expert-row {
    display: grid;
    grid-template-columns: 28px 1fr 110px 90px;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border-bottom: 1px solid #EBEEF5;
    font-size: 13px;

    &:last-child {
      border-bottom: none;
    }

    &.is-disabled {
      opacity: 0.45;
      background: #FAFAFA;
    }

    &.is-random {
      grid-template-columns: 28px 1fr 120px;
    }
  }

  .expert-name {
    color: #303133;
    font-weight: 500;
  }

  .expert-meta {
    color: #909399;
    font-size: 12px;
  }

  .expert-count-input {
    width: 72px;

    /deep/ .el-input__inner {
      text-align: center;
      padding: 0 8px;
    }
  }

  .group-pick-bar {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
  }

  .record-list {
    border: 1px solid #EBEEF5;
    border-radius: 6px;
    overflow: hidden;
  }

  .record-item {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 12px;
    align-items: flex-start;
    padding: 12px 14px;
    border-bottom: 1px solid #EBEEF5;
    background: #fff;
    font-size: 13px;

    &:last-child {
      border-bottom: none;
    }

    &.is-sub {
      background: #FAFBFC;
    }
  }

  .record-title {
    font-weight: 600;
    color: #303133;
    margin-bottom: 4px;
  }

  .record-desc {
    color: #909399;
    font-size: 12px;
    line-height: 1.6;

    strong {
      color: #409EFF;
      font-weight: 600;
    }
  }

  .record-delete {
    color: #F56C6C;
    padding: 0;
  }

  .preview-box {
    padding: 12px 14px;
    background: #FAFAFA;
    border: 1px dashed #DCDFE6;
    border-radius: 6px;
    font-size: 13px;
    color: #606266;
    line-height: 1.7;

    /deep/ .ok {
      color: #67C23A;
      font-weight: 500;
    }

    /deep/ .warn {
      color: #E6A23C;
      font-weight: 500;
    }

    /deep/ .err {
      color: #F56C6C;
      font-weight: 500;
    }
  }

  .empty-text {
    padding: 16px;
    font-size: 13px;
    color: #909399;
    text-align: center;
    width: 100%;
  }

  .nested-tip {
    font-size: 12px;
    color: #909399;
    margin-bottom: 12px;
    line-height: 1.5;
  }

  .nested-expert-list {
    display: flex;
    flex-direction: column;
    border: 1px solid #EBEEF5;
    border-radius: 6px;
    max-height: 280px;
    overflow-y: auto;
  }

  .nested-expert-row {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 8px;
    align-items: center;
    padding: 10px 12px;
    border-bottom: 1px solid #EBEEF5;
    font-size: 13px;
    cursor: pointer;

    &:last-child {
      border-bottom: none;
    }

    &:hover:not(.is-used) {
      background: #FAFBFC;
    }

    &.is-checked {
      background: #ECF5FF;
    }

    &.is-used {
      opacity: 0.55;
      cursor: not-allowed;
      background: #F5F7FA;
      color: #909399;
    }
  }

  .nested-expert-org,
  .used-tag {
    font-size: 12px;
    color: #909399;
    white-space: nowrap;
  }
</style>
